// Complete Look Complementary Products - Interactive Features
// Debug mode toggle: set to false to disable debug output
const DEBUG_MODE = false;

document.addEventListener('DOMContentLoaded', function() {
  if (DEBUG_MODE) console.log('🎯 Complete Look: Initializing interactive features');
  
  // Store selected products and variants - set as global variable for access by other functions
  window.selectedProducts = {};
  const selectedProducts = window.selectedProducts;
  
  // Check if product list is configured
  const hasProductList = document.querySelectorAll('.cl-item').length > 0;
  if (DEBUG_MODE) console.log('🔍 [COMPLETE LOOK] Has product list:', hasProductList);
  
  if (!hasProductList) {
    if (DEBUG_MODE) console.log('⚠️ [COMPLETE LOOK] No product list configured, but button will still work for main product only');
  }
  
  // Initialize product data
  const productItems = document.querySelectorAll('.cl-item');
  productItems.forEach(function(item) {
    const productId = item.dataset.productId;
    const productHandle = item.dataset.productHandle;
    const pcsType = item.dataset.pcsType;
    
    // Initialize product data
    selectedProducts[productId] = {
      handle: productHandle,
      checked: false, // Default not selected
      variants: {}
    };
    
    // Set default PCS quantity and multiplier based on product type
    if (pcsType === 'european') {
      selectedProducts[productId].pcsQuantity = 1;
      selectedProducts[productId].pcsMultiplier = 1;
    } else if (pcsType === 'pillowcases') {
      selectedProducts[productId].pcsQuantity = 2; // Default 2 PACKS
      selectedProducts[productId].pcsMultiplier = 1; // 1 set of 2 PACKS
    }
    
    if (DEBUG_MODE) console.log('📦 Product initialized:', productId, productHandle, 'pcsType:', pcsType);
  });
  
  // Checkbox functionality
  const checkboxes = document.querySelectorAll('.cl-checkbox');
  checkboxes.forEach(function(checkbox) {
    checkbox.addEventListener('change', function() {
      const productItem = this.closest('.cl-item');
      if (!productItem) {
        console.error('⚠️ Complete Look: Product item not found for checkbox');
        return;
      }
      const productId = productItem.dataset.productId;
      const variantsDiv = productItem.querySelector('.cl-variants');
      
      selectedProducts[productId].checked = this.checked;
      
      // If checkbox is checked, expand variant selection module
      if (this.checked) {
        variantsDiv.style.display = 'block';
        
        // Reinitialize variant selection functionality (in case it was cleared before)
        initializeVariantSelection(productItem);
        
        // Sync main product color when checkbox is checked
        syncMainProductColorForProduct(productId, productItem);
        
        if (DEBUG_MODE) console.log('✅ Variants expanded on checkbox select:', productId);
      } else {
        // If checkbox is unchecked, collapse variant selection module and clear all selected states
        variantsDiv.style.display = 'none';
        
        // Clear all variant button selected states
        const variantButtons = variantsDiv.querySelectorAll('.cl-variant-btn');
        variantButtons.forEach(btn => {
          btn.classList.remove('selected');
        });
        
        // Clear all PCS button selected states
        const pcsButtons = variantsDiv.querySelectorAll('.cl-pcs-btn');
        pcsButtons.forEach(btn => {
          btn.classList.remove('selected');
        });
        
        // Reset product data
        selectedProducts[productId].variants = {};
        selectedProducts[productId].selectedVariant = null;
        
        // Reset PCS quantity and multiplier to default values
        const pcsType = productItem.dataset.pcsType;
        if (pcsType === 'european') {
          selectedProducts[productId].pcsQuantity = 1;
          selectedProducts[productId].pcsMultiplier = 1;
        } else if (pcsType === 'pillowcases') {
          selectedProducts[productId].pcsQuantity = 2;
          selectedProducts[productId].pcsMultiplier = 1;
        }
        
        // Note: Not restoring default PCS button selected state, let user actively choose
        if (DEBUG_MODE) console.log('🔄 [CHECKBOX DESELECT] Cleared PCS button selection for product:', productId);
        
        // Reset price display to default price
        const priceElement = productItem.querySelector('.cl-price');
        if (priceElement) {
          const basePrice = priceElement.dataset.basePrice;
          if (basePrice) {
            priceElement.textContent = 'From ' + new Intl.NumberFormat('en-US', {
              style: 'currency',
              currency: 'USD'
            }).format(basePrice / 100);
            priceElement.classList.remove('selected');
          }
        }
        
        if (DEBUG_MODE) console.log('❌ Variants collapsed and cleared on checkbox deselect:', productId);
      }
      
      if (DEBUG_MODE) console.log('☑️ Checkbox changed:', productId, this.checked);
      updateCompleteLookButton();
    });
  });
  
  // Main product color change listener
  function setupMainProductColorListener() {
    if (DEBUG_MODE) console.log('🎨 Setting up main product color listener...');
    
    // Listen for main product color selector changes
    const mainColorSwatches = document.querySelectorAll('.product__color-swatch');
    if (DEBUG_MODE) console.log('🎨 Found main color swatches:', mainColorSwatches.length);
    
    if (mainColorSwatches.length === 0) {
      if (DEBUG_MODE) console.log('⚠️ No main color swatches found, trying alternative selectors...');
      // Try other possible selectors
      const altColorSwatches = document.querySelectorAll('[data-option-name="Colour"], [data-option-name="Color"], .color-swatch, .swatch');
      if (DEBUG_MODE) console.log('🎨 Found alternative color swatches:', altColorSwatches.length);
      
      altColorSwatches.forEach(function(swatch) {
        swatch.addEventListener('click', function() {
          const selectedColor = this.dataset.optionValue || this.dataset.label || this.textContent.trim();
          if (DEBUG_MODE) console.log('🎨 Main product color changed to (alt):', selectedColor);
          
          // Reinitialize entire Complete Look module
          reinitializeCompleteLookModule(selectedColor);
        });
      });
    } else {
      mainColorSwatches.forEach(function(swatch) {
        swatch.addEventListener('click', function() {
          const selectedColor = this.dataset.optionValue || this.dataset.label;
          if (DEBUG_MODE) console.log('🎨 Main product color changed to:', selectedColor);
          
          // Reinitialize entire Complete Look module
          reinitializeCompleteLookModule(selectedColor);
        });
      });
    }
    
    // Listen for main product variant selector changes (backup method)
    const mainVariantSelect = document.querySelector('select[name="id"]:not(.complete-look-variant-select)');
    if (mainVariantSelect) {
      mainVariantSelect.addEventListener('change', function() {
        // Get color information from selected variant
        const selectedOption = this.options[this.selectedIndex];
        if (selectedOption) {
          const colorValue = selectedOption.textContent.trim();
          if (DEBUG_MODE) console.log('🎨 Main product variant changed, color:', colorValue);
          
          // Reinitialize entire Complete Look module
          reinitializeCompleteLookModule(colorValue);
        }
      });
    }
    
    // Listen for main product variant input changes (backup method)
    const mainVariantInput = document.querySelector('input[name="id"]:not([data-complementary])');
    if (mainVariantInput) {
      mainVariantInput.addEventListener('change', function() {
        // Try to get current color from page elements
        const activeColorSwatch = document.querySelector('.product__color-swatch.selected, .product__color-swatch[aria-selected="true"]');
        if (activeColorSwatch) {
          const selectedColor = activeColorSwatch.dataset.optionValue || activeColorSwatch.dataset.label;
          if (DEBUG_MODE) console.log('🎨 Main product variant input changed, color:', selectedColor);
          
          // Reinitialize entire Complete Look module
          reinitializeCompleteLookModule(selectedColor);
        }
      });
    }
  }

  // Reinitialize entire Complete Look module
  function reinitializeCompleteLookModule(selectedColor) {
    if (DEBUG_MODE) console.log('🔄 [REINIT] Reinitializing Complete Look module with color:', selectedColor);
    
    // 1. Reset all complementary product states
    Object.keys(selectedProducts).forEach(productId => {
      const productItem = document.querySelector(`[data-product-id="${productId}"]`);
      if (!productItem) return;
      
      // Reset product data
      selectedProducts[productId] = {
        handle: selectedProducts[productId].handle,
        checked: false,
        variants: {},
        selectedVariant: null,
        pcsQuantity: selectedProducts[productId].pcsQuantity || 1,
        pcsMultiplier: selectedProducts[productId].pcsMultiplier || 1
      };
      
      // Reset UI state
      const checkbox = productItem.querySelector('input[type="checkbox"]');
      if (checkbox) {
        checkbox.checked = false;
      }
      
      const variantsDiv = productItem.querySelector('.cl-variants');
      if (variantsDiv) {
        variantsDiv.style.display = 'none';
      }
      
      // Clear all variant button selected states
      const variantButtons = productItem.querySelectorAll('.cl-variant-btn');
      variantButtons.forEach(btn => btn.classList.remove('selected'));
      
      // Clear all PCS button selected states
      const pcsButtons = productItem.querySelectorAll('.cl-pcs-btn');
      pcsButtons.forEach(btn => btn.classList.remove('selected'));
      
      // Note: Not restoring default PCS button selected state, let user actively choose
      if (DEBUG_MODE) console.log('🔄 [REINIT] Cleared PCS button selection for product:', productId);
      
      // Reset price display to "From XX"
      const priceElement = productItem.querySelector('.cl-price');
      if (priceElement) {
        // Get minimum price from data-base-price attribute
        const basePrice = priceElement.dataset.basePrice;
        if (basePrice) {
          const minPrice = parseInt(basePrice);
          const formattedPrice = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(minPrice / 100);
          priceElement.textContent = 'From ' + formattedPrice;
          priceElement.classList.remove('selected');
          if (DEBUG_MODE) console.log('🔄 [REINIT] Reset price for product:', productId, 'to:', 'From ' + formattedPrice);
        } else {
          if (DEBUG_MODE) console.log('⚠️ [REINIT] No base price found for product:', productId);
        }
      }
      
      if (DEBUG_MODE) console.log('🔄 [REINIT] Reset product:', productId);
    });
    
    // 2. Re-sync colors
    if (DEBUG_MODE) console.log('🔄 [REINIT] Syncing colors with:', selectedColor);
    syncComplementaryColors(selectedColor);
    
    // 3. Reinitialize variant selection functionality
    const productItems = document.querySelectorAll('.cl-item');
    productItems.forEach(function(item) {
      const productId = item.dataset.productId;
      const variantsDiv = item.querySelector('.cl-variants');
      
      if (variantsDiv) {
        // Reinitialize variant selection functionality
        initializeVariantSelection(item);
        
        // Check variant availability
        if (DEBUG_MODE) console.log('🔄 [REINIT] Re-checking availability for product:', productId);
        checkVariantAvailability(item);
      }
    });
    
    // 4. Update button state
    updateCompleteLookButton();
    
    if (DEBUG_MODE) console.log('✅ [REINIT] Complete Look module reinitialized successfully');
  }

  // Sync complementary product colors
  function syncComplementaryColors(mainColor) {
    if (DEBUG_MODE) console.log('🔄 Syncing complementary colors with main color:', mainColor);
    
    if (!mainColor) {
      if (DEBUG_MODE) console.log('⚠️ No main color provided for sync');
      return;
    }
    
    // Iterate through all complementary products, only update color selection, not price
    Object.keys(selectedProducts).forEach(productId => {
      const productItem = document.querySelector(`[data-product-id="${productId}"]`);
      if (!productItem) return;
      
      // Get product variant data
      const variantDataDiv = productItem.querySelector('.cl-variant-data');
      if (!variantDataDiv) return;
      
      // Find matching color variant
      const variantElements = variantDataDiv.querySelectorAll('[data-variant-id]');
      let matchedVariant = null;
      
      variantElements.forEach(variantEl => {
        const variantOptions = variantEl.dataset.variantOptions.split('|');
        if (DEBUG_MODE) console.log('🎨 [SYNC COLORS] Product:', productId, 'Variant options:', variantOptions, 'Looking for:', mainColor);
        
        // Check if contains matching color
        const hasMatchingColor = variantOptions.some(option => 
          option.toLowerCase().trim() === mainColor.toLowerCase().trim()
        );
        
        if (hasMatchingColor) {
          matchedVariant = variantEl;
          if (DEBUG_MODE) console.log('🎨 [SYNC COLORS] Found matching variant for product:', productId);
        }
      });
      
      if (matchedVariant) {
        // Found matching variant, update color selection
        const variantOptions = matchedVariant.dataset.variantOptions.split('|');
        const colorOption = variantOptions.find(option => 
          option.toLowerCase().trim() === mainColor.toLowerCase().trim()
        );
        
        if (colorOption) {
          // Update product color selection state (but not price)
          if (!selectedProducts[productId].variants) {
            selectedProducts[productId].variants = {};
          }
          selectedProducts[productId].variants['Colour'] = colorOption;
          
          // Update color button UI state
          const colorButtons = productItem.querySelectorAll('.cl-variant-btn[data-option="Colour"], .cl-variant-btn[data-option="Color"]');
          colorButtons.forEach(btn => {
            btn.classList.remove('selected');
            if (btn.dataset.value === colorOption) {
              btn.classList.add('selected');
            }
          });
          
          if (DEBUG_MODE) console.log('✅ Synced color for product:', productId, 'to:', colorOption);
        }
      } else {
        // No matching color found, use first available variant
        const firstVariant = variantDataDiv.querySelector('[data-variant-id]');
        if (firstVariant) {
          const variantOptions = firstVariant.dataset.variantOptions.split('|');
          if (DEBUG_MODE) console.log('🎨 [SYNC COLORS] No matching color found for product:', productId, 'First variant options:', variantOptions);
          
          // Try to find color option (might be first, second, or other position)
          let colorOption = null;
          for (let i = 0; i < variantOptions.length; i++) {
            const option = variantOptions[i];
            // Check if this option exists in color buttons
            const colorButton = productItem.querySelector(`.cl-variant-btn[data-option="Colour"][data-value="${option}"], .cl-variant-btn[data-option="Color"][data-value="${option}"]`);
            if (colorButton) {
              colorOption = option;
              break;
            }
          }
          
          if (colorOption) {
            if (!selectedProducts[productId].variants) {
              selectedProducts[productId].variants = {};
            }
            selectedProducts[productId].variants['Colour'] = colorOption;
            
            // Update color button UI state
            const colorButtons = productItem.querySelectorAll('.cl-variant-btn[data-option="Colour"], .cl-variant-btn[data-option="Color"]');
            colorButtons.forEach(btn => {
              btn.classList.remove('selected');
              if (btn.dataset.value === colorOption) {
                btn.classList.add('selected');
              }
            });
            
            if (DEBUG_MODE) console.log('⚠️ [SYNC COLORS] No matching color found for product:', productId, 'using first available color:', colorOption);
          } else {
            if (DEBUG_MODE) console.log('⚠️ [SYNC COLORS] No color option found in variant for product:', productId);
          }
        }
      }
    });
    
    // Re-check availability after color sync
    Object.keys(selectedProducts).forEach(productId => {
      const productItem = document.querySelector(`[data-product-id="${productId}"]`);
      if (productItem) {
        if (DEBUG_MODE) console.log('🔄 [SYNC COLORS] Re-checking availability for product after color sync:', productId);
        checkVariantAvailability(productItem);
      }
    });

    if (DEBUG_MODE) console.log('✅ [SYNC COLORS] Re-checked availability after color sync');
    
    // Note: Not calling updateCompleteLookButton() here, because we're only syncing colors, not updating price
  }

  // Sync main product color for a specific product when checkbox is checked
  function syncMainProductColorForProduct(productId, productItem) {
    if (DEBUG_MODE) console.log('🎨 [SYNC ON CHECKBOX] Syncing main product color for product:', productId);
    
    // Get main product current selected color
    let mainColor = null;
    
    // Try multiple methods to get main product color
    const activeColorSwatch = document.querySelector('.product__color-swatch.selected, .product__color-swatch[aria-selected="true"]');
    if (activeColorSwatch) {
      mainColor = activeColorSwatch.dataset.optionValue || activeColorSwatch.dataset.label;
      if (DEBUG_MODE) console.log('🎨 [SYNC ON CHECKBOX] Got color from active swatch:', mainColor);
    }
    
    // Try alternative selectors if not found
    if (!mainColor) {
      const altColorSwatch = document.querySelector('[data-option-name="Colour"] .selected, [data-option-name="Color"] .selected, .color-swatch.selected, .swatch.selected');
      if (altColorSwatch) {
        mainColor = altColorSwatch.dataset.optionValue || altColorSwatch.dataset.label || altColorSwatch.textContent.trim();
        if (DEBUG_MODE) console.log('🎨 [SYNC ON CHECKBOX] Got color from alt swatch:', mainColor);
      }
    }
    
    // Try from variant select if still not found
    if (!mainColor) {
      const mainVariantSelect = document.querySelector('select[name="id"]:not(.complete-look-variant-select)');
      if (mainVariantSelect && mainVariantSelect.selectedIndex >= 0) {
        const selectedOption = mainVariantSelect.options[mainVariantSelect.selectedIndex];
        if (selectedOption) {
          mainColor = selectedOption.textContent.trim();
          if (DEBUG_MODE) console.log('🎨 [SYNC ON CHECKBOX] Got color from variant select:', mainColor);
        }
      }
    }
    
    if (!mainColor) {
      if (DEBUG_MODE) console.log('⚠️ [SYNC ON CHECKBOX] No main color found');
      return;
    }
    
    // Get product variant data
    const variantDataDiv = productItem.querySelector('.cl-variant-data');
    if (!variantDataDiv) {
      if (DEBUG_MODE) console.log('⚠️ [SYNC ON CHECKBOX] No variant data div found');
      return;
    }
    
    // Find matching color variant
    const variantElements = variantDataDiv.querySelectorAll('[data-variant-id]');
    let matchedVariant = null;
    
    variantElements.forEach(variantEl => {
      const variantOptions = variantEl.dataset.variantOptions.split('|');
      const hasMatchingColor = variantOptions.some(option => 
        option.toLowerCase().trim() === mainColor.toLowerCase().trim()
      );
      
      if (hasMatchingColor) {
        matchedVariant = variantEl;
      }
    });
    
    if (matchedVariant) {
      // Found matching variant
      const variantOptions = matchedVariant.dataset.variantOptions.split('|');
      const colorOption = variantOptions.find(option => 
        option.toLowerCase().trim() === mainColor.toLowerCase().trim()
      );
      
      if (colorOption) {
          // Update product color selection state
          if (!selectedProducts[productId].variants) {
            selectedProducts[productId].variants = {};
          }
          selectedProducts[productId].variants['Colour'] = colorOption;
          
          // Update color button UI state
          const colorButtons = productItem.querySelectorAll('.cl-variant-btn[data-option="Colour"], .cl-variant-btn[data-option="Color"]');
          colorButtons.forEach(btn => {
            btn.classList.remove('selected');
            if (btn.dataset.value === colorOption) {
              btn.classList.add('selected');
            }
          });
          
          if (DEBUG_MODE) console.log('✅ [SYNC ON CHECKBOX] Synced color for product:', productId, 'to:', colorOption);
          
          // Do NOT update price here - only update price when user selects a size variant
          // updateVariantPrice and checkVariantAvailability will be called when size is selected
        }
    } else {
      // No matching color found - try to find first available variant
      const firstAvailableVariant = Array.from(variantElements).find(variantEl => 
        variantEl.dataset.variantAvailable === 'true'
      );
      
      if (firstAvailableVariant) {
        const variantOptions = firstAvailableVariant.dataset.variantOptions.split('|');
        
        // Find color option
        const colorButtons = productItem.querySelectorAll('.cl-variant-btn[data-option="Colour"], .cl-variant-btn[data-option="Color"]');
        let colorOption = null;
        
        for (let i = 0; i < variantOptions.length; i++) {
          const option = variantOptions[i];
          const colorButton = Array.from(colorButtons).find(btn => btn.dataset.value === option);
          if (colorButton) {
            colorOption = option;
            break;
          }
        }
        
        if (colorOption) {
          if (!selectedProducts[productId].variants) {
            selectedProducts[productId].variants = {};
          }
          selectedProducts[productId].variants['Colour'] = colorOption;
          
          // Update color button UI state
          colorButtons.forEach(btn => {
            btn.classList.remove('selected');
            if (btn.dataset.value === colorOption) {
              btn.classList.add('selected');
            }
          });
          
          if (DEBUG_MODE) console.log('⚠️ [SYNC ON CHECKBOX] No matching color, using first available:', colorOption);
          
          // Do NOT update price here - only update price when user selects a size variant
          // updateVariantPrice and checkVariantAvailability will be called when size is selected
        }
      }
    }
  }

  // Initialize variant selection functionality
  function initializeVariantSelection(productItem) {
    const productId = productItem.dataset.productId;
    const variantsDiv = productItem.querySelector('.cl-variants');
    
    if (!variantsDiv) return;
    
    // Add event listeners to variant buttons
    const variantButtons = variantsDiv.querySelectorAll('.cl-variant-btn');
    variantButtons.forEach(function(button) {
      // Remove possible old listeners
      button.removeEventListener('click', handleVariantClick);
      // Add new listener
      button.addEventListener('click', handleVariantClick);
    });
    
    // Add event listeners to PCS buttons
    const pcsButtons = variantsDiv.querySelectorAll('.cl-pcs-btn');
    pcsButtons.forEach(function(button) {
      // Remove possible old listeners
      button.removeEventListener('click', handlePcsClick);
      // Add new listener
      button.addEventListener('click', handlePcsClick);
    });
    
    if (DEBUG_MODE) console.log('🔧 Variant selection re-initialized for product:', productId);
    
    // Check variant availability
    if (DEBUG_MODE) console.log('🔍 [INIT VARIANTS] Checking availability for product:', productId);
    checkVariantAvailability(productItem);
  }
  
  // Check variant availability and mark unavailable options
  function checkVariantAvailability(productItem) {
    const productId = productItem.dataset.productId;
    const variantDataDiv = productItem.querySelector('.cl-variant-data');
    
    if (DEBUG_MODE) console.log('🔍 [AVAILABILITY CHECK] Starting availability check for product:', productId);
    
    if (!variantDataDiv) {
      if (DEBUG_MODE) console.log('❌ [AVAILABILITY CHECK] No variant data div found for product:', productId);
      return;
    }
    
    // Get current selected color from the product's variant data
    const currentSelectedVariants = selectedProducts[productId]?.variants || {};
    let currentColor = currentSelectedVariants['Colour'] || currentSelectedVariants['Color'];
    
    // If no color selected, try to get from main product color
    if (!currentColor) {
      const activeColorSwatch = document.querySelector('.product__color-swatch.selected, .product__color-swatch[aria-selected="true"]');
      if (activeColorSwatch) {
        currentColor = activeColorSwatch.dataset.optionValue || activeColorSwatch.dataset.label;
        if (DEBUG_MODE) console.log('🔍 [AVAILABILITY CHECK] Got color from main product:', currentColor);
      }
    }
    
    if (DEBUG_MODE) console.log('🔍 [AVAILABILITY CHECK] Current selected color:', currentColor);

    // Get all variant buttons
    const variantButtons = productItem.querySelectorAll('.cl-variant-btn');
    if (DEBUG_MODE) console.log('🔍 [AVAILABILITY CHECK] Found variant buttons:', variantButtons.length);

    // Check if this product has any color options (important for products like Mattress Protector)
    const hasColorOptions = Array.from(variantButtons).some(btn =>
      btn.dataset.option === 'Colour' || btn.dataset.option === 'Color'
    );

    // For each variant button, check if any matching variant is available
    variantButtons.forEach((button, index) => {
      const optionName = button.dataset.option;
      const optionValue = button.dataset.value;
      
      if (DEBUG_MODE) console.log(`🔍 [AVAILABILITY CHECK] Button ${index + 1}: ${optionName} = ${optionValue}`);
      
      // Skip color buttons - we only check size/other options
      if (optionName === 'Colour' || optionName === 'Color') {
        if (DEBUG_MODE) console.log(`⏭️ [AVAILABILITY CHECK] Skipping color button: ${optionValue}`);
        return;
      }
      
      // Find all variants that match this option value AND current color
      const variantElements = variantDataDiv.querySelectorAll('[data-variant-id]');
      let hasAvailableVariant = false;
      let availableVariants = [];
      let unavailableVariants = [];
      
      variantElements.forEach((variantEl, variantIndex) => {
        const variantOptions = variantEl.dataset.variantOptions.split('|');
        const isAvailable = variantEl.dataset.variantAvailable === 'true';
        const variantId = variantEl.dataset.variantId;
        
        // Check if this variant contains the option value
        const containsOptionValue = variantOptions.includes(optionValue);

        // Check if this variant matches current color (if color is selected)
        // For products WITHOUT color options (like Mattress Protector), always match
        let matchesCurrentColor = true;
        if (currentColor && hasColorOptions) {
          matchesCurrentColor = variantOptions.includes(currentColor);
        }

        if (DEBUG_MODE) console.log(`🔍 [AVAILABILITY CHECK] Variant ${variantIndex + 1} (ID: ${variantId}):`, {
          options: variantOptions,
          available: isAvailable,
          containsValue: containsOptionValue,
          matchesCurrentColor: matchesCurrentColor,
          relevant: containsOptionValue && matchesCurrentColor
        });
        
        // Check if this variant contains the option value AND matches current color
        if (containsOptionValue && matchesCurrentColor) {
          if (isAvailable) {
            hasAvailableVariant = true;
            availableVariants.push(variantId);
          } else {
            unavailableVariants.push(variantId);
          }
        }
      });
      
      if (DEBUG_MODE) console.log(`🔍 [AVAILABILITY CHECK] Button ${index + 1} (${optionValue}) result:`, {
        hasAvailableVariant: hasAvailableVariant,
        availableVariants: availableVariants,
        unavailableVariants: unavailableVariants,
        currentColor: currentColor
      });
      
      // Mark button as unavailable if no available variants found
      if (!hasAvailableVariant) {
        button.classList.add('unavailable');
        if (DEBUG_MODE) console.log(`❌ [AVAILABILITY CHECK] Marked button as UNAVAILABLE: ${optionValue} (no available variants for color: ${currentColor})`);
      } else {
        button.classList.remove('unavailable');
        if (DEBUG_MODE) console.log(`✅ [AVAILABILITY CHECK] Button remains AVAILABLE: ${optionValue} (has available variants for color: ${currentColor})`);
      }
    });
    
    // Check PCS buttons availability (for Pillowcase products)
    const pcsButtons = productItem.querySelectorAll('.cl-pcs-btn');
    if (pcsButtons.length > 0) {
      if (DEBUG_MODE) console.log('🔍 [AVAILABILITY CHECK] Found PCS buttons:', pcsButtons.length);
      
      // Get all variants that match current color
      const variantElements = variantDataDiv.querySelectorAll('[data-variant-id]');
      let hasAvailableVariantForColor = false;
      
      variantElements.forEach((variantEl) => {
        const variantOptions = variantEl.dataset.variantOptions.split('|');
        const isAvailable = variantEl.dataset.variantAvailable === 'true';
        
        // Check if this variant matches current color (if color is selected)
        // For products WITHOUT color options (like Mattress Protector), always match
        let matchesCurrentColor = true;
        if (currentColor && hasColorOptions) {
          matchesCurrentColor = variantOptions.includes(currentColor);
        }

        // If variant matches current color and is available, mark PCS buttons as available
        if (matchesCurrentColor && isAvailable) {
          hasAvailableVariantForColor = true;
        }
      });
      
      if (DEBUG_MODE) console.log('🔍 [AVAILABILITY CHECK] PCS buttons - has available variant for color:', hasAvailableVariantForColor, 'color:', currentColor);
      
      // Mark all PCS buttons based on color availability
      pcsButtons.forEach((button) => {
        if (!hasAvailableVariantForColor) {
          button.classList.add('unavailable');
          if (DEBUG_MODE) console.log(`❌ [AVAILABILITY CHECK] Marked PCS button as UNAVAILABLE (no available variants for color: ${currentColor})`);
        } else {
          button.classList.remove('unavailable');
          if (DEBUG_MODE) console.log(`✅ [AVAILABILITY CHECK] PCS button remains AVAILABLE (has available variants for color: ${currentColor})`);
        }
      });
    }
    
    if (DEBUG_MODE) console.log('✅ [AVAILABILITY CHECK] Completed availability check for product:', productId);
  }
  
  // Variant button click handler
  function handleVariantClick(e) {
    e.stopPropagation(); // Prevent triggering expand/collapse
    
    // Prevent selection if unavailable
    if (this.classList.contains('unavailable')) {
      if (DEBUG_MODE) console.log('🚫 [VARIANT CLICK] Blocked click on UNAVAILABLE variant:', this.dataset.value);
      return;
    }
    
    if (DEBUG_MODE) console.log('🎯 [VARIANT CLICK] Variant button clicked:', this.dataset.value);
    
    const productItem = this.closest('.cl-item');
    if (!productItem) {
      console.error('⚠️ Complete Look: Product item not found for variant button');
      return;
    }
    const productId = productItem.dataset.productId;
    const option = this.dataset.option;
    const value = this.dataset.value;
    
    if (DEBUG_MODE) console.log('📊 Variant selection data:', { productId, option, value });
    
    // Update selected state
    const optionDiv = this.closest('.cl-option');
    if (!optionDiv) {
      console.error('⚠️ Complete Look: Option div not found for variant button');
      return;
    }
    const buttons = optionDiv.querySelectorAll('.cl-variant-btn');
    
    // Reset all button styles
    buttons.forEach(btn => {
      btn.classList.remove('selected');
    });
    
    // Set selected button style
    this.classList.add('selected');
    
    // Store variant selection
    if (!selectedProducts[productId].variants) {
      selectedProducts[productId].variants = {};
    }
    selectedProducts[productId].variants[option] = value;
    
    // Find corresponding variant and update price
    const productData = productItem.dataset;
    
    // Update price based on selected variant combination
    updateVariantPrice(productId, productItem);
    
    if (DEBUG_MODE) console.log('🎨 Variant selected:', productId, option, value);
    updateCompleteLookButton();
  }
  
  // PCS button click handler
  function handlePcsClick(e) {
    e.stopPropagation(); // Prevent triggering expand/collapse
    
    // Prevent selection if unavailable
    if (this.classList.contains('unavailable')) {
      if (DEBUG_MODE) console.log('🚫 [PCS CLICK] Blocked click on UNAVAILABLE PCS option:', this.dataset.pcs);
      return;
    }
    
    if (DEBUG_MODE) console.log('🔢 [PCS CLICK] PCS button clicked:', this.dataset.pcs);
    
    const productItem = this.closest('.cl-item');
    if (!productItem) {
      console.error('⚠️ Complete Look: Product item not found for PCS button');
      return;
    }
    const productId = productItem.dataset.productId;
    const pcsValue = parseInt(this.dataset.pcs);
    const multiplier = parseInt(this.dataset.multiplier);
    
    if (DEBUG_MODE) console.log('📊 PCS selection data:', { productId, pcsValue, multiplier });
    
    // Update selected state
    const pcsSelection = this.closest('.cl-pcs-selection');
    if (!pcsSelection) {
      console.error('⚠️ Complete Look: PCS selection not found for PCS button');
      return;
    }
    const buttons = pcsSelection.querySelectorAll('.cl-pcs-btn');
    
    // Reset all button styles
    buttons.forEach(btn => {
      btn.classList.remove('selected');
    });
    
    // Set selected button style
    this.classList.add('selected');
    
    // Store PCS selection
    selectedProducts[productId].pcsQuantity = pcsValue;
    selectedProducts[productId].pcsMultiplier = multiplier;
    
    // Update price display
    updateVariantPrice(productId, productItem);
    
    if (DEBUG_MODE) console.log('🔢 PCS selected:', productId, pcsValue, 'multiplier:', multiplier);
    updateCompleteLookButton();
  }

  // Initial variant selection functionality
  const variantButtons = document.querySelectorAll('.cl-variant-btn');
  if (DEBUG_MODE) console.log('🔧 Found variant buttons:', variantButtons.length);
  
  variantButtons.forEach(function(button) {
    button.addEventListener('click', handleVariantClick);
  });
  
  // PCS selection functionality
  const pcsButtons = document.querySelectorAll('.cl-pcs-btn');
  if (DEBUG_MODE) console.log('🔢 Found PCS buttons:', pcsButtons.length);
  
  pcsButtons.forEach(function(button) {
    button.addEventListener('click', handlePcsClick);
  });
  
  // Initial availability check for all products
  productItems.forEach(function(item) {
    if (DEBUG_MODE) console.log('🔍 [INIT] Running initial availability check for product:', item.dataset.productId);
    checkVariantAvailability(item);
  });
  
  // Update price display
  function updatePriceDisplay(productId, variantPrice, compareAtPrice) {
    const priceElement = document.querySelector(`.cl-price[data-product-id="${productId}"]`);
    if (priceElement) {
      // Ensure price is not 0
      if (variantPrice && variantPrice > 0) {
        // Check if PCS quantity and multiplier are set
        const pcsQuantity = selectedProducts[productId]?.pcsQuantity || 1;
        const pcsMultiplier = selectedProducts[productId]?.pcsMultiplier || 1;
        const totalPrice = variantPrice * pcsMultiplier;
        
        const formattedPrice = new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: 'USD'
        }).format(totalPrice / 100);
        
        // Check if product is checked and variant is selected
        const isChecked = selectedProducts[productId]?.checked;
        
        if (isChecked && compareAtPrice && compareAtPrice > 0) {
          const totalComparePrice = compareAtPrice * pcsMultiplier;
          const formattedComparePrice = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD'
          }).format(totalComparePrice / 100);
          
          priceElement.innerHTML =
           `<span class="cl-price-current">${formattedPrice}</span>
            <span class="cl-price-compare">${formattedComparePrice}</span>
      
          `;
        } else {
          priceElement.textContent = formattedPrice;
        }
        
        priceElement.classList.add('selected'); // Add selected state style
        if (DEBUG_MODE) console.log('💰 Price updated:', productId, formattedPrice, '(PCS:', pcsQuantity, 'Multiplier:', pcsMultiplier, ')');
      } else {
        if (DEBUG_MODE) console.log('⚠️ Invalid price for product:', productId, variantPrice);
        // Keep original price unchanged
      }
    } else {
      if (DEBUG_MODE) console.log('❌ Price element not found for product:', productId);
    }
  }
  
  // Update price based on variant selection
  function updateVariantPrice(productId, productItem) {
    const selectedVariants = selectedProducts[productId].variants;
    
    if (DEBUG_MODE) console.log('🔍 [UPDATE VARIANT PRICE] Product:', productId, 'Selected variants:', selectedVariants);
    
    // Find matching variant from hidden variant data
    const variantDataDiv = productItem.querySelector('.cl-variant-data');
    if (!variantDataDiv) {
      if (DEBUG_MODE) console.log('❌ Variant data not found for product:', productId);
      return;
    }
    
    // Build selected variant options array
    const selectedOptions = [];
    Object.values(selectedVariants).forEach(value => {
      selectedOptions.push(value);
    });
    
    if (DEBUG_MODE) console.log('🔍 [UPDATE VARIANT PRICE] Selected options:', selectedOptions);
    
    // Find matching variant
    const variantElements = variantDataDiv.querySelectorAll('[data-variant-id]');
    let matchedVariant = null;
    
    if (DEBUG_MODE) console.log('🔍 [UPDATE VARIANT PRICE] Available variants:', variantElements.length);
    
    // If there are selected variant options, try to match
    if (selectedOptions.length > 0) {
      if (DEBUG_MODE) console.log('🔍 [UPDATE VARIANT PRICE] Trying to match variants...');
      variantElements.forEach((variantEl, index) => {
        const variantOptions = variantEl.dataset.variantOptions.split('|');
        if (DEBUG_MODE) console.log(`🔍 [UPDATE VARIANT PRICE] Variant ${index}:`, variantOptions);
        
        // Check if all selected options match
        const isMatch = selectedOptions.every(selectedOption => 
          variantOptions.includes(selectedOption)
        );
        
        if (DEBUG_MODE) console.log(`🔍 [UPDATE VARIANT PRICE] Variant ${index} match:`, isMatch, 'Length match:', selectedOptions.length === variantOptions.length);
        
        // Modified matching logic: as long as all selected options match, length doesn't need to be exactly equal
        if (isMatch) {
          matchedVariant = variantEl;
          if (DEBUG_MODE) console.log('✅ [UPDATE VARIANT PRICE] Found matching variant:', variantEl.dataset.variantId);
        }
      });
    } else {
      // If no variant options selected, use first available variant (default variant)
      matchedVariant = variantElements[0];
      if (DEBUG_MODE) console.log('🔄 No variants selected, using default variant for:', productId);
      
      // Even when using default variant, update price display
      if (matchedVariant) {
        const variantPrice = parseInt(matchedVariant.dataset.variantPrice);
        const compareAtPrice = matchedVariant.dataset.variantCompareAtPrice ? 
                               parseInt(matchedVariant.dataset.variantCompareAtPrice) : null;
        const variantId = matchedVariant.dataset.variantId;
        
        // Update price display
        updatePriceDisplay(productId, variantPrice, compareAtPrice);
        
        // Store selected variant information
        selectedProducts[productId].selectedVariant = {
          id: variantId,
          price: variantPrice,
          compareAtPrice: compareAtPrice,
          variants: selectedVariants
        };
        
        if (DEBUG_MODE) console.log('🎯 Default variant applied:', productId, variantId, variantPrice / 100);
      }
    }
    
    // Process matched variant
    if (matchedVariant) {
      const variantPrice = parseInt(matchedVariant.dataset.variantPrice);
      const compareAtPrice = matchedVariant.dataset.variantCompareAtPrice ? 
                             parseInt(matchedVariant.dataset.variantCompareAtPrice) : null;
      const variantId = matchedVariant.dataset.variantId;
      
      if (DEBUG_MODE) console.log('🎯 [UPDATE VARIANT PRICE] Processing matched variant:', variantId, 'Price:', variantPrice);
      
      // Update price display
      updatePriceDisplay(productId, variantPrice, compareAtPrice);
      
      // Store selected variant information
      selectedProducts[productId].selectedVariant = {
        id: variantId,
        price: variantPrice,
        compareAtPrice: compareAtPrice,
        variants: selectedVariants
      };
      
      if (DEBUG_MODE) console.log('✅ [UPDATE VARIANT PRICE] Variant processed successfully:', productId, variantId, variantPrice / 100, selectedVariants);
    } else {
      if (DEBUG_MODE) console.log('⚠️ [UPDATE VARIANT PRICE] No matching variant found for:', productId, selectedVariants);
      // If no matching variant found, keep original price
    }
  }
  
  // Hide native add-to-cart button
  function hideNativeAddToCartButton() {
    const nativeButtonContainer = document.querySelector('.product-form__item--submit');
    if (nativeButtonContainer) {
      nativeButtonContainer.style.display = 'none';
      if (DEBUG_MODE) console.log('✅ [COMPLETE LOOK] Native add-to-cart button hidden');
    } else {
      if (DEBUG_MODE) console.log('⚠️ [COMPLETE LOOK] Native button container not found');
    }
  }

  // Initialize our own button
  function initializeCompleteLookButton() {
    const buttonContainer = document.querySelector('.cl-add-to-cart-container');
    const button = document.getElementById('complete-look-add-to-cart-btn');
    
    if (!buttonContainer || !button) {
      if (DEBUG_MODE) console.log('⚠️ [COMPLETE LOOK] Button elements not found, retrying...');
      setTimeout(initializeCompleteLookButton, 1000);
      return;
    }
    
    if (DEBUG_MODE) console.log('✅ [COMPLETE LOOK] Button elements found, setting up...');
    
    // Hide native button
    hideNativeAddToCartButton();
    
    // Show our button
    buttonContainer.style.display = 'block';
    buttonContainer.style.position = 'relative';
    buttonContainer.style.width = '100%';
    
    // Initialize button state
    updateCompleteLookButton();
    
    // Listen for variant changes
    setupVariantListener();
  }

  // Setup variant listener
  function setupVariantListener() {
    // Listen for variant selector changes
    const variantSelect = document.querySelector('select[name="id"]');
    if (variantSelect) {
      variantSelect.addEventListener('change', updateCompleteLookButton);
    }
    
    // Listen for price changes
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'childList' || mutation.type === 'characterData') {
          updateCompleteLookButton();
        }
      });
    });
    
    const priceElement = document.querySelector('.price__current, .product__price, .price');
    if (priceElement) {
      observer.observe(priceElement, { childList: true, subtree: true, characterData: true });
    }
    
    // // Periodically update button state (as backup)
    // setInterval(updateCompleteLookButton, 2000);
  }
  
  // Check main product variant availability
  function checkMainVariantAvailability(variantId) {
    if (!variantId) {
      if (DEBUG_MODE) console.log('⚠️ [AVAILABILITY CHECK] No variant ID provided');
      return false;
    }
    
    // Try to find product JSON script tag (id format: ProductJson-*)
    const productJsonScript = document.querySelector('script[id^="ProductJson-"]');
    if (!productJsonScript) {
      if (DEBUG_MODE) console.log('⚠️ [AVAILABILITY CHECK] Product JSON script not found');
      return false; // Default to unavailable for safety
    }
    
    try {
      const productData = JSON.parse(productJsonScript.textContent);
      if (!productData.variants || !Array.isArray(productData.variants)) {
        if (DEBUG_MODE) console.log('⚠️ [AVAILABILITY CHECK] Product variants array not found');
        return false;
      }
      
      // Convert variantId to number for comparison (handle both string and number IDs)
      const variantIdNum = parseInt(variantId, 10);
      
      // Find matching variant
      const variant = productData.variants.find(v => {
        const vId = typeof v.id === 'number' ? v.id : parseInt(v.id, 10);
        return vId === variantIdNum;
      });
      
      if (!variant) {
        if (DEBUG_MODE) console.log('⚠️ [AVAILABILITY CHECK] Variant not found in product JSON:', variantId);
        return false;
      }
      
      // Check availability property
      const isAvailable = variant.available === true;
      if (DEBUG_MODE) console.log('✅ [AVAILABILITY CHECK] Variant availability:', variantId, 'available:', isAvailable);
      
      return isAvailable;
    } catch (e) {
      if (DEBUG_MODE) console.log('❌ [AVAILABILITY CHECK] Error parsing product JSON:', e);
      return false; // Default to unavailable for safety
    }
  }

  // Update our own add-to-cart button
  function updateCompleteLookButton() {
    const buttonContainer = document.querySelector('.cl-add-to-cart-container');
    const button = document.getElementById('complete-look-add-to-cart-btn');
    
    if (DEBUG_MODE) console.log('🔄 [COMPLETE LOOK] Updating button...', {
      containerFound: !!buttonContainer,
      buttonFound: !!button
    });
    
    if (!button || !buttonContainer) {
      if (DEBUG_MODE) console.log('⚠️ [COMPLETE LOOK] Button elements not found');
      return;
    }
    
    // Calculate selected products
    let selectedCount = 0;
    let totalPrice = 0;
    let totalCompareAtPrice = 0;
    
    Object.keys(selectedProducts).forEach(productId => {
      const product = selectedProducts[productId];
      if (product.checked) {
        selectedCount++;
        
        // Get PCS quantity and multiplier
        const pcsQuantity = product.pcsQuantity || 1;
        const pcsMultiplier = product.pcsMultiplier || 1;
        
        if (product.selectedVariant) {
          // If user selected variant, use selected variant price
          const variantTotalPrice = product.selectedVariant.price * pcsMultiplier;
          totalPrice += variantTotalPrice;
          
          // Calculate compare-at price if available
          if (product.selectedVariant.compareAtPrice && product.selectedVariant.compareAtPrice > 0) {
            const variantTotalCompareAtPrice = product.selectedVariant.compareAtPrice * pcsMultiplier;
            totalCompareAtPrice += variantTotalCompareAtPrice;
            if (DEBUG_MODE) console.log('✓ Selected product with variant:', product.selectedVariant.id, 'compare-at:', product.selectedVariant.compareAtPrice, 'x', pcsMultiplier, '=', variantTotalCompareAtPrice);
          }
          
          if (DEBUG_MODE) console.log('✓ Selected product with variant:', product.selectedVariant.id, product.selectedVariant.price, 'x', pcsMultiplier, '=', variantTotalPrice);
        } else {
          // If user didn't select variant, don't calculate price (avoid updating price just by expanding)
          if (DEBUG_MODE) console.log('⚠️ Product checked but no variant selected:', productId);
        }
      }
    });
    
    if (DEBUG_MODE) console.log('📊 [COMPLETE LOOK] Selected products:', selectedCount, 'Total price:', totalPrice, 'Total compare-at price:', totalCompareAtPrice);
    
    // Get main product price - try to get from ProductJson first, then fallback to page element
    let mainProductPrice = 0;
    
    // First, try to get variant ID to fetch price from ProductJson
    let tempVariantId = null;
    const tempVariantSelect = document.querySelector('select[name="id"]:not(.complete-look-variant-select)');
    if (tempVariantSelect) {
      tempVariantId = tempVariantSelect.value;
    } else {
      const tempVariantInput = document.querySelector('input[name="id"]:not([data-complementary])');
      if (tempVariantInput) {
        tempVariantId = tempVariantInput.value;
      }
    }
    
    // Try to get price and compare-at price from ProductJson if variant ID is available
    let mainProductCompareAtPrice = 0;
    if (tempVariantId) {
      const productJsonScript = document.querySelector('script[id^="ProductJson-"]');
      if (productJsonScript) {
        try {
          const productData = JSON.parse(productJsonScript.textContent);
          if (productData.variants && Array.isArray(productData.variants)) {
            const variantIdNum = parseInt(tempVariantId, 10);
            const variant = productData.variants.find(v => {
              const vId = typeof v.id === 'number' ? v.id : parseInt(v.id, 10);
              return vId === variantIdNum;
            });
            if (variant) {
              if (variant.price) {
                mainProductPrice = typeof variant.price === 'number' ? variant.price : parseInt(variant.price, 10);
                if (DEBUG_MODE) console.log('💰 [COMPLETE LOOK] Main product price from ProductJson:', mainProductPrice / 100);
              }
              if (variant.compare_at_price && variant.compare_at_price > 0) {
                mainProductCompareAtPrice = typeof variant.compare_at_price === 'number' ? variant.compare_at_price : parseInt(variant.compare_at_price, 10);
                if (DEBUG_MODE) console.log('💰 [COMPLETE LOOK] Main product compare-at price from ProductJson:', mainProductCompareAtPrice / 100);
              }
            }
          }
        } catch (e) {
          if (DEBUG_MODE) console.log('⚠️ [COMPLETE LOOK] Error parsing ProductJson:', e);
        }
      }
    }
    
    // Fallback to page element if ProductJson method didn't work
    if (mainProductPrice === 0) {
      const priceElement = document.querySelector('.price__current, .product__price, .price');
      if (priceElement) {
        // Use more precise price extraction method
        const priceText = priceElement.textContent.trim();
        const priceMatch = priceText.match(/\$?(\d+\.?\d*)/);
        if (priceMatch) {
          mainProductPrice = parseFloat(priceMatch[1]) * 100; // Convert to cents
          if (DEBUG_MODE) console.log('💰 [COMPLETE LOOK] Main product price from page element:', mainProductPrice / 100);
        }
      }
    }
    
    // Fallback to page element for compare-at price if ProductJson method didn't work
    if (mainProductCompareAtPrice === 0) {
      const comparePriceElement = document.querySelector('[data-compare-price] .priceRange');
      if (comparePriceElement) {
        const comparePriceText = comparePriceElement.textContent.trim();
        const comparePriceMatch = comparePriceText.match(/\$?(\d+\.?\d*)/);
        if (comparePriceMatch) {
          mainProductCompareAtPrice = parseFloat(comparePriceMatch[1]) * 100; // Convert to cents
          if (DEBUG_MODE) console.log('💰 [COMPLETE LOOK] Main product compare-at price from page element:', mainProductCompareAtPrice / 100);
        }
      } else {
        // Try alternative selector
        const comparePriceElementAlt = document.querySelector('[data-compare-price]');
        if (comparePriceElementAlt && comparePriceElementAlt.textContent.trim()) {
          const comparePriceText = comparePriceElementAlt.textContent.trim();
          const comparePriceMatch = comparePriceText.match(/\$?(\d+\.?\d*)/);
          if (comparePriceMatch) {
            mainProductCompareAtPrice = parseFloat(comparePriceMatch[1]) * 100; // Convert to cents
            if (DEBUG_MODE) console.log('💰 [COMPLETE LOOK] Main product compare-at price from page element (alt):', mainProductCompareAtPrice / 100);
          }
        }
      }
    }
    
    // Get main product variant ID - try multiple methods
    // First try multiple form selectors
    let mainForm = document.querySelector('form[action*="/cart/add"]');
    if (!mainForm) {
      mainForm = document.querySelector('form[action*="cart"]');
    }
    if (!mainForm) {
      mainForm = document.querySelector('form.product-form');
    }
    if (!mainForm) {
      mainForm = document.querySelector('form[data-product-form]');
    }
    if (!mainForm) {
      mainForm = document.querySelector('form');
    }
    
    let mainVariantId = null;
    
    if (DEBUG_MODE) console.log('🔍 [COMPLETE LOOK] Looking for main form:', !!mainForm);
    
    // If form found, print form info
    if (mainForm) {
      if (DEBUG_MODE) console.log('🔍 [COMPLETE LOOK] Form found:', {
        action: mainForm.action,
        className: mainForm.className,
        id: mainForm.id,
        method: mainForm.method
      });
    } else {
      // If no form found, print all forms on page
      const allForms = document.querySelectorAll('form');
      if (DEBUG_MODE) console.log('🔍 [COMPLETE LOOK] All forms on page:', allForms.length);
      allForms.forEach((form, index) => {
        if (DEBUG_MODE) console.log(`🔍 [COMPLETE LOOK] Form ${index}:`, {
          action: form.action,
          className: form.className,
          id: form.id,
          method: form.method
        });
      });
    }
    
    // If form found but no select/input inside, try to find other possible product forms
    if (mainForm && mainForm.querySelectorAll('select, input').length === 0) {
      if (DEBUG_MODE) console.log('⚠️ [COMPLETE LOOK] Found form but no select/input elements, searching for product form...');
      
      // Try to find other forms containing product related elements
      const productForms = document.querySelectorAll('form');
      productForms.forEach((form, index) => {
        const hasSelects = form.querySelectorAll('select').length;
        const hasInputs = form.querySelectorAll('input').length;
        const hasProductElements = form.querySelectorAll('[data-product-id], [data-variant-id], .product-form, .variant-selector').length;
        
        if (hasSelects > 0 || hasInputs > 0 || hasProductElements > 0) {
          if (DEBUG_MODE) console.log(`🔍 [COMPLETE LOOK] Potential product form ${index}:`, {
            action: form.action,
            className: form.className,
            id: form.id,
            selects: hasSelects,
            inputs: hasInputs,
            productElements: hasProductElements
          });
          
          // If this form looks more like a product form, use it
          if (hasProductElements > 0 || (hasSelects > 0 && form.action.includes('cart')) || (hasSelects > 0 && form.action.includes('product'))) {
            mainForm = form;
            if (DEBUG_MODE) console.log('✅ [COMPLETE LOOK] Using alternative product form:', {
              action: form.action,
              selects: hasSelects,
              inputs: hasInputs,
              productElements: hasProductElements
            });
          }
        }
      });
    }
    
    if (mainForm) {
      // Method 1: Find select[name="id"]
      const variantSelect = mainForm.querySelector('select[name="id"]');
      if (DEBUG_MODE) console.log('🔍 [COMPLETE LOOK] Variant select found:', !!variantSelect);
      
      if (variantSelect) {
        mainVariantId = variantSelect.value;
        if (DEBUG_MODE) console.log('🆔 [COMPLETE LOOK] Main variant ID from select:', mainVariantId);
      } else {
        // Method 2: Find hidden input[name="id"]
        const variantInput = mainForm.querySelector('input[name="id"]');
        if (DEBUG_MODE) console.log('🔍 [COMPLETE LOOK] Variant input found:', !!variantInput);
        
        if (variantInput) {
          mainVariantId = variantInput.value;
          if (DEBUG_MODE) console.log('🆔 [COMPLETE LOOK] Main variant ID from input:', mainVariantId);
        } else {
          // Method 3: Find data-variant-id attribute
          const variantElement = mainForm.querySelector('[data-variant-id]');
          if (DEBUG_MODE) console.log('🔍 [COMPLETE LOOK] Variant element with data-variant-id found:', !!variantElement);
          
          if (variantElement) {
            mainVariantId = variantElement.dataset.variantId;
            if (DEBUG_MODE) console.log('🆔 [COMPLETE LOOK] Main variant ID from data-variant-id:', mainVariantId);
          } else {
            // Method 4: Find all possible variant selectors
            const allSelects = mainForm.querySelectorAll('select');
            const allInputs = mainForm.querySelectorAll('input');
            if (DEBUG_MODE) console.log('🔍 [COMPLETE LOOK] All selects in form:', allSelects.length);
            if (DEBUG_MODE) console.log('🔍 [COMPLETE LOOK] All inputs in form:', allInputs.length);
            
            // Print name attribute of all select and input
            allSelects.forEach((select, index) => {
              if (DEBUG_MODE) console.log(`🔍 [COMPLETE LOOK] Select ${index}:`, select.name, select.value);
            });
            allInputs.forEach((input, index) => {
              if (DEBUG_MODE) console.log(`🔍 [COMPLETE LOOK] Input ${index}:`, input.name, input.value, input.type);
            });
          }
        }
      }
    } else {
      if (DEBUG_MODE) console.log('❌ [COMPLETE LOOK] Main form not found');
    }
    
    // If variant ID not found through form, try to get directly from page elements
    if (!mainVariantId) {
      if (DEBUG_MODE) console.log('🔍 [COMPLETE LOOK] Trying to get variant ID from page elements...');
      
      // Method 5: Get directly from page variant selector (exclude complementary product area)
      const pageVariantSelect = document.querySelector('select[name="id"]:not(.complete-look-variant-select)');
      if (pageVariantSelect) {
        mainVariantId = pageVariantSelect.value;
        if (DEBUG_MODE) console.log('🆔 [COMPLETE LOOK] Main variant ID from page select:', mainVariantId);
      } else {
        // Method 6: Get from page variant input (exclude complementary product area)
        const pageVariantInput = document.querySelector('input[name="id"]:not([data-complementary])');
        if (pageVariantInput) {
          mainVariantId = pageVariantInput.value;
          if (DEBUG_MODE) console.log('🆔 [COMPLETE LOOK] Main variant ID from page input:', mainVariantId);
        } else {
          // Method 7: Get from page data-variant-id attribute (exclude complementary product area)
          const pageVariantElements = document.querySelectorAll('[data-variant-id]');
          let mainVariantElement = null;
          
          // Find variant element not in complementary product area
          for (let element of pageVariantElements) {
            if (!element.closest('.complete-look-product-item') && 
                !element.closest('.complementary-products') &&
                !element.closest('[data-product-id]')) {
              mainVariantElement = element;
              break;
            }
          }
          
          if (mainVariantElement) {
            mainVariantId = mainVariantElement.dataset.variantId;
            if (DEBUG_MODE) console.log('🆔 [COMPLETE LOOK] Main variant ID from page data-variant-id:', mainVariantId);
          } else {
            // Method 8: Get from product JSON data
            const productJson = document.querySelector('script[type="application/json"][data-product-json]');
            if (productJson) {
              try {
                const productData = JSON.parse(productJson.textContent);
                if (productData.selected_or_first_available_variant) {
                  mainVariantId = productData.selected_or_first_available_variant.id.toString();
                  if (DEBUG_MODE) console.log('🆔 [COMPLETE LOOK] Main variant ID from product JSON:', mainVariantId);
                }
              } catch (e) {
                if (DEBUG_MODE) console.log('❌ [COMPLETE LOOK] Error parsing product JSON:', e);
              }
            }
            
            // Method 9: If still not found, try to get from product form area
            if (!mainVariantId) {
              const productFormArea = document.querySelector('.product-form, .product__form, .product-details');
              if (productFormArea) {
                const formVariantSelect = productFormArea.querySelector('select[name="id"]');
                const formVariantInput = productFormArea.querySelector('input[name="id"]');
                const formVariantElement = productFormArea.querySelector('[data-variant-id]');
                
                if (formVariantSelect) {
                  mainVariantId = formVariantSelect.value;
                  if (DEBUG_MODE) console.log('🆔 [COMPLETE LOOK] Main variant ID from product form select:', mainVariantId);
                } else if (formVariantInput) {
                  mainVariantId = formVariantInput.value;
                  if (DEBUG_MODE) console.log('🆔 [COMPLETE LOOK] Main variant ID from product form input:', mainVariantId);
                } else if (formVariantElement) {
                  mainVariantId = formVariantElement.dataset.variantId;
                  if (DEBUG_MODE) console.log('🆔 [COMPLETE LOOK] Main variant ID from product form data-variant-id:', mainVariantId);
                }
              }
            }
            
            // Method 10: If still not found, analyze all select elements on page
            if (!mainVariantId) {
              if (DEBUG_MODE) console.log('🔍 [COMPLETE LOOK] Analyzing all select elements on page...');
              const allSelects = document.querySelectorAll('select');
              allSelects.forEach((select, index) => {
                if (DEBUG_MODE) console.log(`🔍 [COMPLETE LOOK] Select ${index}:`, {
                  name: select.name,
                  value: select.value,
                  className: select.className,
                  id: select.id,
                  parentElement: select.parentElement?.tagName,
                  parentClassName: select.parentElement?.className
                });
                
                // If this select has name="id" and is not in complementary product area
                if (select.name === 'id' && 
                    !select.closest('.complete-look-product-item') && 
                    !select.closest('.complementary-products') &&
                    !select.closest('[data-product-id]')) {
                  mainVariantId = select.value;
                  if (DEBUG_MODE) console.log('🆔 [COMPLETE LOOK] Main variant ID from analyzed select:', mainVariantId);
                }
              });
            }
          }
        }
      }
    }
    
    // Update button display - button always shows, price changes with selection
    if (mainVariantId) {
      // Check main variant availability
      const isMainVariantAvailable = checkMainVariantAvailability(mainVariantId);
      
      buttonContainer.style.display = 'block';
      const combinedTotal = (mainProductPrice + totalPrice) / 100;
      const combinedCompareAtTotal = (mainProductCompareAtPrice + totalCompareAtPrice) / 100;
      
      // Use debounce mechanism to avoid price flickering
      if (window.buttonUpdateTimeout) {
        clearTimeout(window.buttonUpdateTimeout);
      }
      
      window.buttonUpdateTimeout = setTimeout(() => {
        button.textContent = `ADD TO CART - $${combinedTotal.toFixed(2)}`;
        
        // DISABLED: Update main product price display
        // Commented out by user request - 2024-XX-XX
        // const mainPriceElement = document.querySelector('.fs-heading-4-base[data-price] .priceRange');
        // if (mainPriceElement) {
        //   mainPriceElement.textContent = `$${combinedTotal.toFixed(2)}`;
        //   if (DEBUG_MODE) console.log('💰 [COMPLETE LOOK] Main price updated:', combinedTotal);
        // } else {
        //   // Try alternative selector if .priceRange is not found
        //   const mainPriceElementAlt = document.querySelector('.fs-heading-4-base[data-price]');
        //   if (mainPriceElementAlt) {
        //     // Check if it contains priceRange or update directly
        //     const priceRangeInAlt = mainPriceElementAlt.querySelector('.priceRange');
        //     if (priceRangeInAlt) {
        //       priceRangeInAlt.textContent = `$${combinedTotal.toFixed(2)}`;
        //     } else {
        //       // Update the element itself if no .priceRange found
        //       const priceText = mainPriceElementAlt.textContent.trim();
        //       // Replace the price part while keeping other content
        //       mainPriceElementAlt.textContent = mainPriceElementAlt.textContent.replace(/\$?[\d,]+\.?\d*/g, `$${combinedTotal.toFixed(2)}`);
        //     }
        //     if (DEBUG_MODE) console.log('💰 [COMPLETE LOOK] Main price updated (alt selector):', combinedTotal);
        //   }
        // }
        
        // DISABLED: Update compare-at price display
        // Commented out by user request - 2024-XX-XX
        // if (combinedCompareAtTotal > 0 && combinedCompareAtTotal > combinedTotal) {
        //   const comparePriceElement = document.querySelector('[data-compare-price] .priceRange');
        //   if (comparePriceElement) {
        //     comparePriceElement.textContent = `$${combinedCompareAtTotal.toFixed(2)}`;
        //     // Ensure parent element is visible
        //     const comparePriceParent = comparePriceElement.closest('[data-compare-price]');
        //     if (comparePriceParent) {
        //       comparePriceParent.style.display = '';
        //     }
        //     if (DEBUG_MODE) console.log('💰 [COMPLETE LOOK] Compare-at price updated:', combinedCompareAtTotal);
        //   } else {
        //     // Try alternative selector
        //     const comparePriceElementAlt = document.querySelector('[data-compare-price]');
        //     if (comparePriceElementAlt) {
        //       const priceRangeInCompare = comparePriceElementAlt.querySelector('.priceRange');
        //       if (priceRangeInCompare) {
        //         priceRangeInCompare.textContent = `$${combinedCompareAtTotal.toFixed(2)}`;
        //       } else {
        //         // Update the element itself if no .priceRange found
        //         comparePriceElementAlt.textContent = comparePriceElementAlt.textContent.replace(/\$?[\d,]+\.?\d*/g, `$${combinedCompareAtTotal.toFixed(2)}`);
        //       }
        //       // Ensure element is visible
        //       comparePriceElementAlt.style.display = '';
        //       if (DEBUG_MODE) console.log('💰 [COMPLETE LOOK] Compare-at price updated (alt selector):', combinedCompareAtTotal);
        //     }
        //   }
        //   
        //   // Calculate and update Save percentage
        //   const discountAmount = combinedCompareAtTotal - combinedTotal;
        //   const discountPercentage = Math.round((discountAmount / combinedCompareAtTotal) * 100);
        //   const savePercentageElement = document.querySelector('[data-save-percentage]');
        //   if (savePercentageElement) {
        //     savePercentageElement.textContent = `Save ${discountPercentage}%`;
        //     // Ensure element is visible
        //     savePercentageElement.style.display = '';
        //     if (DEBUG_MODE) console.log('💰 [COMPLETE LOOK] Save percentage updated:', discountPercentage + '%');
        //   }
        // } else {
        //   // Hide compare-at price and save percentage if no discount
        //   const comparePriceElement = document.querySelector('[data-compare-price]');
        //   if (comparePriceElement) {
        //     comparePriceElement.style.display = 'none';
        //   }
        //   const savePercentageElement = document.querySelector('[data-save-percentage]');
        //   if (savePercentageElement) {
        //     savePercentageElement.style.display = 'none';
        //   }
        //   if (DEBUG_MODE) console.log('💰 [COMPLETE LOOK] No discount, hiding compare-at price and save percentage');
        // }
        
        // DISABLED: Update Afterpay component data-amount attribute
        // Commented out by user request
        // const afterpayElements = document.querySelectorAll('square-placement[data-amount]');
        // if (afterpayElements.length > 0) {
        //   afterpayElements.forEach(afterpayEl => {
        //     afterpayEl.setAttribute('data-amount', combinedTotal.toFixed(2));
        //     if (DEBUG_MODE) console.log('💳 [COMPLETE LOOK] Afterpay data-amount updated:', combinedTotal);
        //   });
        // } else {
        //   // Try without [data-amount] selector in case it's not set initially
        //   const afterpayElementsAlt = document.querySelectorAll('square-placement');
        //   afterpayElementsAlt.forEach(afterpayEl => {
        //     afterpayEl.setAttribute('data-amount', combinedTotal.toFixed(2));
        //     if (DEBUG_MODE) console.log('💳 [COMPLETE LOOK] Afterpay data-amount updated (alt selector):', combinedTotal);
        //   });
        // }
        
        // Disable button if variant is out of stock
        if (!isMainVariantAvailable) {
          button.disabled = true;
          button.style.opacity = '0.6';
          button.style.cursor = 'not-allowed';
          if (DEBUG_MODE) console.log('🚫 [COMPLETE LOOK] Button disabled - variant out of stock:', mainVariantId);
        } else {
          button.disabled = false;
          button.style.opacity = '1';
          button.style.cursor = 'pointer';
          if (DEBUG_MODE) console.log('✅ [COMPLETE LOOK] Button UPDATED:', {
            mainPrice: mainProductPrice / 100,
            complementaryTotal: totalPrice / 100,
            total: combinedTotal,
            selectedItems: selectedCount,
            variantAvailable: true
          });
        }
      }, 100); // 100ms debounce
    } else {
      // If no main product variant, show default price
      buttonContainer.style.display = 'block';
      button.textContent = 'ADD TO CART - $0.00';
      button.disabled = true;
      button.style.opacity = '0.6';
      if (DEBUG_MODE) console.log('⚠️ [COMPLETE LOOK] Button shown but disabled - no main variant');
    }
    
    // Update promotion message
    updatePromotionMessage();
  }
  
  // ============================================
  // 动态促销提示功能
  // ============================================
  
  /**
   * 更新促销提示信息
   * 根据当前选中的产品总数计算 X 值
   * X = 目标总数(3) - 当前总数量(主产品1 + 选中配套产品)
   * 选中条件：勾选了 checkbox + 选择了变体（selectedVariant 不为 null）
   */
  function updatePromotionMessage() {
    // 计算当前选中的配套产品数量
    // 选中条件：checked 为 true 且 selectedVariant 不为 null
    let selectedComplementaryCount = 0;
    Object.keys(selectedProducts).forEach(productId => {
      const product = selectedProducts[productId];
      const hasChecked = product.checked === true;
      const hasSelectedVariant = product.selectedVariant && product.selectedVariant !== null;
      
      if (DEBUG_MODE) {
        console.log('🎁 [PROMOTION] 检查产品:', productId, {
          checked: hasChecked,
          hasSelectedVariant: hasSelectedVariant,
          isSelected: hasChecked && hasSelectedVariant
        });
      }
      
      if (hasChecked && hasSelectedVariant) {
        selectedComplementaryCount++;
      }
    });
    
    // 目标总数 = 主产品(1) + 配套产品(2) = 3
    const TARGET_TOTAL = 3;
    const mainProductCount = 1;
    const complementaryGoal = 2;
    
    // 当前总数量 = 主产品 + 选中的配套产品
    const currentTotal = mainProductCount + selectedComplementaryCount;
    
    // X = 目标总数 - 当前总数量
    const X = Math.max(0, TARGET_TOTAL - currentTotal);
    
    // 获取元素
    const promotionMessage = document.querySelector('.cl-promotion-message');
    const promotionCount = document.querySelector('.cl-promotion-count');
    const discountMessage = document.querySelector('.cl-discount-message');
    
    if (DEBUG_MODE) {
      console.log('🎁 [PROMOTION] 更新促销提示:', {
        selectedComplementaryCount,
        currentTotal,
        X
      });
    }
    
    if (X > 0) {
      // 显示促销提示
      if (promotionMessage) {
        promotionMessage.style.display = 'block';
        if (promotionCount) {
          promotionCount.textContent = X;
        }
      }
      // 隐藏折扣提示
      if (discountMessage) {
        discountMessage.style.display = 'none';
      }
    } else {
      // 隐藏促销提示
      if (promotionMessage) {
        promotionMessage.style.display = 'none';
      }
      // 显示折扣提示
      if (discountMessage) {
        discountMessage.style.display = 'block';
      }
    }
    
    if (DEBUG_MODE) {
      console.log('🎁 [PROMOTION] 促销提示更新完成');
    }
  }
  
  // Toggle variant option display/hide
  window.toggleVariants = function(element) {
    const productItem = element.closest('.cl-item');
    if (!productItem) {
      console.error('⚠️ Complete Look: Product item not found for toggle');
      return;
    }
    const variantsDiv = productItem.querySelector('.cl-variants');
    const checkbox = productItem.querySelector('.cl-checkbox');
    const productId = productItem.dataset.productId;
    
    // Toggle display state
    const isVisible = variantsDiv.style.display !== 'none';
    variantsDiv.style.display = isVisible ? 'none' : 'block';
    
    // If expanding variant options, auto-select the product
    if (!isVisible) {
      checkbox.checked = true;
      selectedProducts[productId].checked = true;
      if (DEBUG_MODE) console.log('✅ Auto-selected product on expand:', productId);
      updateCompleteLookButton();
    }
  };

  // Our own add-to-cart logic
  function setupCartIntegration() {
    if (DEBUG_MODE) console.log('🔧 [COMPLETE LOOK] Setting up our own add to cart button...');
    
    const button = document.getElementById('complete-look-add-to-cart-btn');
    const messageDiv = document.querySelector('.cl-cart-message');
    
    if (!button) {
      console.error('❌ [COMPLETE LOOK] Our button not found');
      return;
    }
    
    if (DEBUG_MODE) console.log('✅ [COMPLETE LOOK] Button found, attaching click handler');
    
    button.addEventListener('click', function(e) {
      e.preventDefault();
      if (DEBUG_MODE) console.log('🚀 [COMPLETE LOOK] Our button clicked!');
      
      // Disable button to prevent duplicate clicks
      button.disabled = true;
      button.style.opacity = '0.6';
      button.textContent = 'Adding to cart...';
      
    // Get main product info - try multiple methods
    // First try multiple form selectors
    let mainForm = document.querySelector('form[action*="/cart/add"]');
    if (!mainForm) {
      mainForm = document.querySelector('form[action*="cart"]');
    }
    if (!mainForm) {
      mainForm = document.querySelector('form.product-form');
    }
    if (!mainForm) {
      mainForm = document.querySelector('form[data-product-form]');
    }
    if (!mainForm) {
      mainForm = document.querySelector('form[action*="product"]');
    }
    if (!mainForm) {
      mainForm = document.querySelector('form');
    }
    
      if (!mainForm) {
        console.error('❌ [COMPLETE LOOK] Main form not found');
        showMessage('Error: Form not found', 'error');
        return;
      }
      
    if (DEBUG_MODE) console.log('🔍 [COMPLETE LOOK] Cart form found:', {
      action: mainForm.action,
      className: mainForm.className,
      id: mainForm.id
    });
    
    // Try multiple methods to get main product variant ID - use same logic as button update
    let mainVariantId = null;
    
    // Method 1: Get from within form
      const variantSelect = mainForm.querySelector('select[name="id"]');
    const variantInput = mainForm.querySelector('input[name="id"]');
    const variantElement = mainForm.querySelector('[data-variant-id]');
    
    if (variantSelect) {
      mainVariantId = variantSelect.value;
      if (DEBUG_MODE) console.log('🆔 [COMPLETE LOOK] Cart - Main variant ID from form select:', mainVariantId);
    } else if (variantInput) {
      mainVariantId = variantInput.value;
      if (DEBUG_MODE) console.log('🆔 [COMPLETE LOOK] Cart - Main variant ID from form input:', mainVariantId);
    } else if (variantElement) {
      mainVariantId = variantElement.dataset.variantId;
      if (DEBUG_MODE) console.log('🆔 [COMPLETE LOOK] Cart - Main variant ID from form data-variant-id:', mainVariantId);
    }
    
    // If not found in form, get from page elements (exclude complementary product area)
    if (!mainVariantId) {
      if (DEBUG_MODE) console.log('🔍 [COMPLETE LOOK] Cart - Trying to get variant ID from page elements...');
      
      // Method 5: Get directly from page variant selector (exclude complementary product area)
      const pageVariantSelect = document.querySelector('select[name="id"]:not(.complete-look-variant-select)');
      if (pageVariantSelect) {
        mainVariantId = pageVariantSelect.value;
        if (DEBUG_MODE) console.log('🆔 [COMPLETE LOOK] Cart - Main variant ID from page select:', mainVariantId);
      } else {
        // Method 6: Get from page variant input (exclude complementary product area)
        const pageVariantInput = document.querySelector('input[name="id"]:not([data-complementary])');
        if (pageVariantInput) {
          mainVariantId = pageVariantInput.value;
          if (DEBUG_MODE) console.log('🆔 [COMPLETE LOOK] Cart - Main variant ID from page input:', mainVariantId);
        } else {
          // Method 7: Get from page data-variant-id attribute (exclude complementary product area)
          const pageVariantElements = document.querySelectorAll('[data-variant-id]');
          let mainVariantElement = null;
          
          // Find variant element not in complementary product area
          for (let element of pageVariantElements) {
            if (!element.closest('.complete-look-product-item') && 
                !element.closest('.complementary-products') &&
                !element.closest('[data-product-id]')) {
              mainVariantElement = element;
              break;
            }
          }
          
          if (mainVariantElement) {
            mainVariantId = mainVariantElement.dataset.variantId;
            if (DEBUG_MODE) console.log('🆔 [COMPLETE LOOK] Cart - Main variant ID from page data-variant-id:', mainVariantId);
          } else {
            // Method 8: Get from product JSON data
            const productJson = document.querySelector('script[type="application/json"][data-product-json]');
            if (productJson) {
              try {
                const productData = JSON.parse(productJson.textContent);
                if (productData.selected_or_first_available_variant) {
                  mainVariantId = productData.selected_or_first_available_variant.id.toString();
                  if (DEBUG_MODE) console.log('🆔 [COMPLETE LOOK] Cart - Main variant ID from product JSON:', mainVariantId);
                }
              } catch (e) {
                if (DEBUG_MODE) console.log('❌ [COMPLETE LOOK] Cart - Error parsing product JSON:', e);
              }
            }
            
            // Method 9: If still not found, try to get from product form area
            if (!mainVariantId) {
              const productFormArea = document.querySelector('.product-form, .product__form, .product-details');
              if (productFormArea) {
                const formVariantSelect = productFormArea.querySelector('select[name="id"]');
                const formVariantInput = productFormArea.querySelector('input[name="id"]');
                const formVariantElement = productFormArea.querySelector('[data-variant-id]');
                
                if (formVariantSelect) {
                  mainVariantId = formVariantSelect.value;
                  if (DEBUG_MODE) console.log('🆔 [COMPLETE LOOK] Cart - Main variant ID from product form select:', mainVariantId);
                } else if (formVariantInput) {
                  mainVariantId = formVariantInput.value;
                  if (DEBUG_MODE) console.log('🆔 [COMPLETE LOOK] Cart - Main variant ID from product form input:', mainVariantId);
                } else if (formVariantElement) {
                  mainVariantId = formVariantElement.dataset.variantId;
                  if (DEBUG_MODE) console.log('🆔 [COMPLETE LOOK] Cart - Main variant ID from product form data-variant-id:', mainVariantId);
                }
              }
            }
            
            // Method 10: If still not found, analyze all select elements on page
            if (!mainVariantId) {
              if (DEBUG_MODE) console.log('🔍 [COMPLETE LOOK] Cart - Analyzing all select elements on page...');
              const allSelects = document.querySelectorAll('select');
              allSelects.forEach((select, index) => {
                if (DEBUG_MODE) console.log(`🔍 [COMPLETE LOOK] Cart - Select ${index}:`, {
                  name: select.name,
                  value: select.value,
                  className: select.className,
                  id: select.id,
                  parentElement: select.parentElement?.tagName,
                  parentClassName: select.parentElement?.className
                });
                
                // If this select has name="id" and is not in complementary product area
                if (select.name === 'id' && 
                    !select.closest('.complete-look-product-item') && 
                    !select.closest('.complementary-products') &&
                    !select.closest('[data-product-id]')) {
                  mainVariantId = select.value;
                  if (DEBUG_MODE) console.log('🆔 [COMPLETE LOOK] Cart - Main variant ID from analyzed select:', mainVariantId);
                }
              });
            }
          }
        }
      }
    }
    
    if (!mainVariantId) {
      console.error('❌ [COMPLETE LOOK] Cart - Main variant ID not found');
        showMessage('Error: Please select a variant', 'error');
        // Reset button
        button.disabled = false;
        button.style.opacity = '1';
        updateCompleteLookButton();
        return;
      }
      
    // Check main variant availability before adding to cart
    const isMainVariantAvailable = checkMainVariantAvailability(mainVariantId);
    if (!isMainVariantAvailable) {
      if (DEBUG_MODE) console.log('🚫 [COMPLETE LOOK] Cart - Main variant is out of stock:', mainVariantId);
      showMessage('Product variant is out of stock', 'error');
      // Reset button
      button.disabled = false;
      button.style.opacity = '1';
      updateCompleteLookButton();
      return;
    }
      
    const quantityInput = mainForm.querySelector('input[name="quantity"]');
      const mainQuantity = quantityInput ? parseInt(quantityInput.value) : 1;
      
      if (DEBUG_MODE) console.log('📦 [COMPLETE LOOK] Main product:', mainVariantId, 'x', mainQuantity, 'available:', isMainVariantAvailable);
      
      // Collect all items to add
      const itemsToAdd = [];
      
      // Add main product
      const mainProductItem = {
        id: mainVariantId,
        quantity: mainQuantity
      };
      itemsToAdd.push(mainProductItem);
      if (DEBUG_MODE) console.log('📦 [COMPLETE LOOK] Main product item:', mainProductItem);
      
      // Add selected complementary products
      if (DEBUG_MODE) console.log('🔍 [COMPLETE LOOK] Checking selectedProducts:', selectedProducts);
      Object.keys(selectedProducts).forEach(productId => {
        const product = selectedProducts[productId];
        if (DEBUG_MODE) console.log(`🔍 [COMPLETE LOOK] Product ${productId}:`, product);
        if (product.checked) {
          let variantId = null;
          
          if (product.selectedVariant) {
            // If user selected variant, use selected variant
            variantId = product.selectedVariant.id;
            if (DEBUG_MODE) console.log('➕ [COMPLETE LOOK] Adding complementary with selected variant:', variantId);
          } else {
            // If user didn't select variant, check if there's any available variant matching main product color
            const productItem = document.querySelector(`[data-product-id="${productId}"]`);
            if (productItem) {
              const variantDataDiv = productItem.querySelector('.cl-variant-data');
              if (variantDataDiv) {
                // Get current main product color
                const activeColorSwatch = document.querySelector('.product__color-swatch.selected, .product__color-swatch[aria-selected="true"]');
                let mainColor = null;
                if (activeColorSwatch) {
                  mainColor = activeColorSwatch.dataset.optionValue || activeColorSwatch.dataset.label;
                }
                
                if (mainColor) {
                  // Look for first available variant matching main color
                  const variantElements = variantDataDiv.querySelectorAll('[data-variant-id]');
                  for (let variantEl of variantElements) {
                    const variantOptions = variantEl.dataset.variantOptions.split('|');
                    const isAvailable = variantEl.dataset.variantAvailable === 'true';
                    const matchesColor = variantOptions.some(option => 
                      option.toLowerCase().trim() === mainColor.toLowerCase().trim()
                    );
                    
                    if (matchesColor && isAvailable) {
                      variantId = variantEl.dataset.variantId;
                      if (DEBUG_MODE) console.log('➕ [COMPLETE LOOK] Adding complementary with matching color variant:', variantId, 'color:', mainColor);
                      break;
                    }
                  }
                  
                  if (!variantId) {
                    if (DEBUG_MODE) console.log('⚠️ [COMPLETE LOOK] No available variant matching main color for product:', productId, 'color:', mainColor, '- skipping this product');
                  }
                } else {
                  if (DEBUG_MODE) console.log('⚠️ [COMPLETE LOOK] No main color found, skipping product:', productId);
                }
              }
            }
          }
          
          if (variantId) {
            // Get PCS quantity and multiplier
            const pcsQuantity = product.pcsQuantity || 1;
            const pcsMultiplier = product.pcsMultiplier || 1;
            
            itemsToAdd.push({
              id: variantId,
              quantity: pcsMultiplier
            });
            if (DEBUG_MODE) console.log('✅ [COMPLETE LOOK] Added complementary product:', variantId, 'quantity:', pcsMultiplier, '(PCS:', pcsQuantity, ')');
          } else {
            if (DEBUG_MODE) console.log('⚠️ [COMPLETE LOOK] No variant found for product:', productId, '- skipping');
          }
        }
      });
      
      if (DEBUG_MODE) console.log('🛒 [COMPLETE LOOK] Total items to add:', itemsToAdd.length, itemsToAdd);
      
      // Use Shopify Cart API to add products
      addToCart(itemsToAdd);
    });
    
    function addToCart(items) {
      if (DEBUG_MODE) console.log('🔄 [COMPLETE LOOK] Calling Shopify Cart API...');
      if (DEBUG_MODE) console.log('📤 [COMPLETE LOOK] Request payload:', JSON.stringify({ items: items }, null, 2));
      
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ items: items })
      })
      .then(response => {
        if (DEBUG_MODE) console.log('📡 [COMPLETE LOOK] Response status:', response.status);
        if (DEBUG_MODE) console.log('📡 [COMPLETE LOOK] Response headers:', response.headers);
        
        if (!response.ok) {
          return response.text().then(text => {
            console.error('❌ [COMPLETE LOOK] Response error text:', text);
            throw new Error(`HTTP error! status: ${response.status}, text: ${text}`);
          });
        }
        return response.json();
      })
      .then(data => {
        if (DEBUG_MODE) console.log('✅ [COMPLETE LOOK] Cart API success:', data);
        
        // Check returned data to see which products were successfully added
        if (data.items && data.items.length > 0) {
          if (DEBUG_MODE) console.log('📦 [COMPLETE LOOK] Successfully added items:', data.items.length);
          data.items.forEach((item, index) => {
            if (DEBUG_MODE) console.log(`📦 [COMPLETE LOOK] Item ${index + 1}:`, {
              variant_id: item.variant_id,
              product_id: item.product_id,
              title: item.title,
              quantity: item.quantity
            });
          });
        } else {
          if (DEBUG_MODE) console.log('⚠️ [COMPLETE LOOK] No items returned in response');
        }
        
        showMessage(`✓ Added ${items.length} items to cart!`, 'success');
        
        // Reset button
        setTimeout(() => {
          button.disabled = false;
          button.style.opacity = '1';
          updateCompleteLookButton();
        }, 1500);
      })
      .catch(error => {
        console.error('❌ [COMPLETE LOOK] Cart API error:', error);
        showMessage('Error adding to cart. Please try again.', 'error');
        
        // Reset button
        button.disabled = false;
        button.style.opacity = '1';
        updateCompleteLookButton();
      });
    }
    
    function showMessage(text, type) {
      if (!messageDiv) return;
      
      messageDiv.textContent = text;
      messageDiv.style.display = 'block';
      messageDiv.className = `cl-cart-message ${type}`;
      
      if (DEBUG_MODE) console.log(`💬 [COMPLETE LOOK] Message: ${text}`);
      
      // Hide message after 3 seconds
      setTimeout(() => {
        messageDiv.style.display = 'none';
      }, 3000);
    }
    
    if (DEBUG_MODE) console.log('✅ [COMPLETE LOOK] Our button ready');
  }
  

  // Immediately hide native button
  hideNativeAddToCartButton();
  
  // Initialize button state and position
  initializeCompleteLookButton();
  
  // Initialize cart integration
  setupCartIntegration();
  
  // Setup main product color listener
  setupMainProductColorListener();
  
  // Initialize color sync
  function initializeColorSync() {
    if (DEBUG_MODE) console.log('🎨 [INIT COLOR SYNC] Starting color sync initialization...');
    
    // Get current main product color selection
    const activeColorSwatch = document.querySelector('.product__color-swatch.selected, .product__color-swatch[aria-selected="true"]');
    if (DEBUG_MODE) console.log('🎨 [INIT COLOR SYNC] Active color swatch found:', !!activeColorSwatch);
    
    if (activeColorSwatch) {
      const selectedColor = activeColorSwatch.dataset.optionValue || activeColorSwatch.dataset.label;
      if (DEBUG_MODE) console.log('🎨 [INIT COLOR SYNC] Initializing color sync with:', selectedColor);
      syncComplementaryColors(selectedColor);
    } else {
      if (DEBUG_MODE) console.log('🎨 [INIT COLOR SYNC] No active color swatch found, trying alternative methods...');
      
      // Try other possible selectors
      const altActiveSwatch = document.querySelector('[data-option-name="Colour"] .selected, [data-option-name="Color"] .selected, .color-swatch.selected, .swatch.selected');
      if (altActiveSwatch) {
        const selectedColor = altActiveSwatch.dataset.optionValue || altActiveSwatch.dataset.label || altActiveSwatch.textContent.trim();
        if (DEBUG_MODE) console.log('🎨 [INIT COLOR SYNC] Found alternative active swatch:', selectedColor);
        syncComplementaryColors(selectedColor);
      } else {
        // If no selected color found, try to get from variant selector
        const mainVariantSelect = document.querySelector('select[name="id"]:not(.complete-look-variant-select)');
        if (DEBUG_MODE) console.log('🎨 [INIT COLOR SYNC] Main variant select found:', !!mainVariantSelect);
        
        if (mainVariantSelect && mainVariantSelect.selectedIndex >= 0) {
          const selectedOption = mainVariantSelect.options[mainVariantSelect.selectedIndex];
          if (selectedOption) {
            const colorValue = selectedOption.textContent.trim();
            if (DEBUG_MODE) console.log('🎨 [INIT COLOR SYNC] Initializing color sync from variant select:', colorValue);
            syncComplementaryColors(colorValue);
          }
        } else {
          if (DEBUG_MODE) console.log('⚠️ [INIT COLOR SYNC] No color information found for initialization');
        }
      }
    }
  }
  
  // Ensure button is updated correctly after page load
  setTimeout(() => {
    updateCompleteLookButton();
    // Ensure native button is hidden again
    hideNativeAddToCartButton();
    // Initialize color sync
    initializeColorSync();
  }, 100);

  if (DEBUG_MODE) console.log('✅ Complete Look: Interactive features initialized');
});

